import React from 'react';

import { NcConsentBundle } from './NcConsentBundle';
import { NcDelawareConsent } from './NcDelawareConsent';

import '@consumer-bootstrap/netcredit.scss';
// eslint-disable-next-line import/order
import '@consumer-bootstrap/brands/netcredit/consents.scss';

export const consentRequiredError = 'You must agree to continue.';

export type NcConsentsPropsT = {
  // Consent bundle checkbox (always shown)
  consentBundleChecked?: boolean;
  consentBundleDefaultChecked?: boolean;
  consentBundleError?: string;
  // Delaware itemization checkbox (shown only when isDelaware=true)
  delawareConsentChecked?: boolean;
  delawareConsentDefaultChecked?: boolean;
  delawareConsentError?: string;
  isCalifornia?: boolean;
  isDelaware?: boolean;
  onConsentBundleChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onDelawareConsentChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

// CodeCov is incorrectly flagging the lines re: state-based content as missed. They are fully covered.
// istanbul ignore next -- @preserve
export const NcConsents = ({
  isCalifornia = false,
  isDelaware = false,
  consentBundleChecked,
  consentBundleDefaultChecked,
  consentBundleError,
  onConsentBundleChange,
  delawareConsentChecked,
  delawareConsentDefaultChecked,
  delawareConsentError,
  onDelawareConsentChange,
}: NcConsentsPropsT) => {
  return (
    <div className="nc-consents">
      <p className="fineprint">
        To check eligibility, apply for and/or obtain a loan or a line of credit through NetCredit,
        you must agree to the following:
      </p>

      <NcConsentBundle
        checked={consentBundleChecked}
        defaultChecked={consentBundleDefaultChecked}
        errorMessage={consentBundleError}
        onChange={onConsentBundleChange}
      />

      {/* istanbul ignore next -- @preserve */}
      {isDelaware && (
        <NcDelawareConsent
          checked={delawareConsentChecked}
          defaultChecked={delawareConsentDefaultChecked}
          errorMessage={delawareConsentError}
          onChange={onDelawareConsentChange}
        />
      )}

      {/* istanbul ignore next -- @preserve */}
      {isCalifornia && (
        <p className="fineprint">For California residents: Married persons may apply for an account in their own name.</p>
      )}
    </div>
  );
};
